<template>
  <div :class="$style.topbar">
    <div class="mr-md-4 mr-auto">
    </div>
    <div class="mr-auto d-none d-md-block">
    </div>
    <div class="mr-4 d-none d-sm-block">
      <air-language-switcher />
    </div>
    <div class>
      <air-user-menu />
    </div>
  </div>
</template>

<script>
import AirLanguageSwitcher from '@/components/layout/TopBar/LanguageSwitcher';
import AirUserMenu from '@/components/layout/TopBar/UserMenu';

export default {
  components: {
    AirLanguageSwitcher,
    AirUserMenu,
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
